import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_EXPENSE_URL || 'https://your-api-gateway-url.amazonaws.com/prod';
const user = JSON.parse(localStorage.getItem('user'));
let token;

if (user) {
  token = user.token;
}
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': token
  },
});

export const accountService = {
  // Get all accounts
  async getAccounts() {
    let data = { cmd: "getAccounts", user: user}
    const response = await api.post('/expenses', data);
    return JSON.parse(response.data.body);
  },

  // Create a new account
  async createAccount(accountData) {
    let data = { cmd: "createAccount", data: accountData};
    data.user = user;
    const response = await api.post('/expenses', data);
    return response.data;
  },

  // Update an account
  async updateAccount(accountId, accountData) {
    accountData.accountId = accountId;
    const data = { cmd: "updateAccount", data: accountData, user: user}
    const response = await api.post(`/expenses`, data);
    return response.data;
  },

  // Delete an account
  async deleteAccount(accountId) {
    const data = { cmd: "deleteAccount", accountId: accountId, user: user };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  // Create a bucket in an account
  async createBucket(accountId, bucketData) {
    bucketData.accountId = accountId;
    let data = { cmd: "createBucket", data: bucketData};
    data.user = user;
    const response = await api.post('/expenses', data);
    return response.data;
  },

  // Update a bucket
  async updateBucket(accountId, bucketId, bucketData) {
    bucketData.accountId = accountId;
    bucketData.bucketId = bucketId;
    const data = { cmd: "updateBucket", data: bucketData, user: user}
    const response = await api.post(`/expenses`, data);
    return response.data;
  },

  // Delete a bucket
  async deleteBucket(accountId, bucketId) {
    const data = { cmd: "deleteBucket", data: {accountId: accountId, bucketId: bucketId}, user: user };
    const response = await api.post('/expenses', data);
    return response.data;
  }
};